import List from './list/MarketplaceCommunityLocationListInitialState'

const { Record } = require('immutable')

export default Record({
    list: new List()
})